export default "__VITE_ASSET__CO93vKus__";